import React from "react";
import { useTranslation } from "react-i18next";
import { Button, AddonsCardsList } from "../../shared";
import { useSlicedData } from "../../../hooks";

const AddonsListing = (props) => {
  const { setAddonsView, offers, variants, recommendedOffers, cart, setCart, setLoader } = props;

  const { t } = useTranslation();
  const slicedRecommendations = useSlicedData(recommendedOffers);
  const slicedOffers = useSlicedData(offers);
  const slicedVariants = useSlicedData(variants);

  const goForward = () => setAddonsView(2);

  const quantity = cart.offers.length + cart.products.length;

  return (
    <div className="track-addons" id="track-addons">
      <div className="addons-listing">
        <div className="container-fluid p-0">
          <h2>{t("addons.mainHeading")}</h2>
          <p className="no-general">{t("addons.headDescription")}</p>
          <div className="track-addons-panel">
            <AddonsCardsList
              {...{
                type: "upsell",
                addons: {
                  recommendations: slicedRecommendations,
                  offers: slicedOffers,
                  variants: slicedVariants
                },
                cart,
                setCart,
                goForward,
                setLoader
              }}
            />
            <div className="actions text-center">
              <Button type="big-roundedRight" action={goForward} disabled={!quantity}>
                {t("addons.checkoutBtn")}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(AddonsListing);
